import { dateFormat } from '@mirai/locale';

import { parseCustomData, sendData } from './helpers';
import { getOccupationTotals } from '../../../../components/helpers';
import { getFirstOccupationOption } from '../helpers';
import { formatPrice } from '../helpers/legacy';

export const ratesAddToCart = async ({
  instances = [],
  metaEventId,
  response: { board: { id, rateId, roomId } = {}, infantAge, tracking = {} } = {},
  store: {
    finder: { calendar = [], occupation = [], place: { id: [hotelId] = [], isHotel } = {} } = {},
    hotel = {},
  } = {},
} = {}) => {
  // ! -- TODO: use of tracking should be a temporary approach ---------------------------------------------------------
  const { country, hotelInfo: { currency: hotelCurrency = {}, propertyName } = {}, rates = [] } = tracking;

  const { totalPrice } = getFirstOccupationOption({ rates, roomId })?.rates[rateId]?.boardOptions[id] || {};
  const catalogHotelId = isHotel ? hotelId : hotel.id;
  const contents = [{ id: catalogHotelId, itemPrice: formatPrice(totalPrice, hotelCurrency), quantity: 1 }];
  const { adults = 0, babies = 0, children = 0 } = getOccupationTotals({ infantAge, occupation });
  const hasDates = calendar.length === 2;

  const commonData = {
    customData: parseCustomData({
      contentIds: [catalogHotelId].filter(Boolean),
      contents,
      country,
      ...(hasDates
        ? {
            checkinDate: dateFormat(calendar[0], { delimiter: '-', format: 'YYYY-MM-DD' }),
            checkoutDate: dateFormat(calendar[1], { delimiter: '-', format: 'YYYY-MM-DD' }),
          }
        : undefined),
      hotelCurrency,
      miraiRate: rateId,
      miraiRoom: roomId,
      numItems: 1,
      numAdults: adults,
      numChildren: babies + children,
      propertyName,
    }),
    eventName: 'AddToCart',
  };

  const responses = await Promise.all(
    instances.map(({ idTracking, pixelId }) => sendData({ ...commonData, eventId: metaEventId, idTracking, pixelId })),
  ).catch(() => {});

  return responses;
};
